module.exports = __webpack_public_path__ + "img/f25c7c3.png";